var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.label ? 'label' : 'span',{tag:"component",staticClass:"cr-radio",class:( _obj = {
    'cr-radio-disabled': _vm.disabled
  }, _obj[("cr-color-" + _vm.color)] = _vm.color, _obj )},[_c('input',{attrs:{"id":_vm.inputId,"name":_vm.name,"disabled":_vm.disabled,"type":"radio"},domProps:{"checked":_vm.checked,"value":_vm.value},on:{"change":_vm.onChange}}),_c('i',{staticClass:"cr-radio-icon"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }